import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteStation(interfaceId: string, id: string): Promise<void> {
  await stationDataConfigApi.delete(interfaceId, id)
}

function useDeleteStation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: any) => deleteStation(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.stations])
        NotifyService.success(t('DeleteStationSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  // return mutate
}

export default useDeleteStation
